import React, { Component } from 'react';
import { connect } from "react-redux";

import { withTranslation } from 'react-i18next';
import {showError} from "../../actions/action_error_alert";
import {Modal, Button} from 'react-bootstrap'


class PopupErrorGochiCharge extends Component { 
  render() { 
    const { t } = this.props;

    return ( 
      <Modal show={this.props.showing} onHide={this.props.onHide} className="modal-error-gochi-charge" centered> 
        <div className="modal-body"> 
          <Button variant="secondary" className="close" onClick={this.props.onHide}>&times;</Button>

          <div className="input-infor">
            <div >
              {this.props.title !== '' &&
                <h5 className="space-pre-line title-error-gochi-charge">{this.props.title}</h5>
              }

              {this.props.content &&
                <p className="space-pre-line content-error-gochi-charge">{this.props.content}</p>
              }
              {this.props.gotoUrl && 
                <a href={this.props.gotoUrl} className="btn btn-green-38 w-240 m-auto mt-3 btn-error-gochi-charge" onClick={this.props.onHide}>
                  {this.props.buttonName}
                </a>
              }
            </div>
          </div>
        </div> 
      </Modal>

    );
  }
}

const mapStateToProps = state => ({
  ...state
});

const mapDispatchToProps = dispatch => ({
  hideError: () => dispatch(showError(false))
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PopupErrorGochiCharge));
